import Player from './player';
import Action from 'actions';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import {createOriginalPosition, getSelectablePositionsMap} from 'components/molecules/player-position/helpers';
import Const from 'constants';

export default class PlayerClassic extends Player {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const state = Action.getState();
        const {playersLock} = state;

        const builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('doublePosition');
        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('externalId');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('positionName');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const {sportConfig} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        expandedPlayer.originalPosition = createOriginalPosition(expandedPlayer);
        expandedPlayer.positionName = expandedPlayer.originalPosition.slug;
        expandedPlayer.position = expandedPlayer.originalPosition.numbers;
        expandedPlayer.selectablePositionsMap =
            expandedPlayer.position.length > 1 ? getSelectablePositionsMap(expandedPlayer.position, sportConfig) : {};

        return {
            ...expandedPlayer,
            isFitForLineup(substitutablePlayer) {
                if (substitutablePlayer.positionInLineup === Const.POSITION_UTIL) {
                    return true;
                }

                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === 'G/F') {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['SG', 'PG', 'SF', 'PF']));
                }

                if (substitutablePlayer.positionInLineup === 'F/C') {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['SF', 'PF', 'C']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.setTeamNameStackingFromStorage(data.teamNameStacking));
        }
    }

    getPlayerById({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const [playerId, positionKey] = id.split(Const.LP_ITEM_DELIMITER);

        const player = {...players[playerId]};

        player.position = positionKey ? Number(positionKey) : Number(player.position[0]);

        return player;
    }
}
